import { render, staticRenderFns } from "./CompanyTransferRecieveModal.vue?vue&type=template&id=71dbb91e&"
import script from "./CompanyTransferRecieveModal.vue?vue&type=script&lang=js&"
export * from "./CompanyTransferRecieveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports